module.exports = __webpack_public_path__ + "static/img/detail-mulan.227eee17.png";